import { ModelBase } from '../../core/model/model-base';

export class DwellingInspectionType extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.name = dataContext.name;
      this.isDefaultType = dataContext.isDefaultType;
    }
  }

  name: string;
  isDefaultType: boolean;

  toString(): string {
    return `${this.name}`;
  }
}
